import React from 'react';
import styles from '../../css/NavBar.module.css';
import { Link, useLocation } from 'react-router-dom';
import { FaBook, FaHome, FaInfo, FaPhoneAlt, FaTools } from 'react-icons/fa';

function BottomNav() {
	const location = useLocation();

	const data = [
		{
			id: 0,
			title: 'Home',
			navi: '/',
			icon: <FaHome />,
		},
		{ id: 1, title: 'Services', navi: '/Service', icon: <FaTools /> },
		{ id: 2, title: 'Course', navi: '/Course', icon: <FaBook /> },
		{ id: 3, title: 'About', navi: '/About', icon: <FaInfo /> },
		{ id: 4, title: 'Contact', navi: '/Contact', icon: <FaPhoneAlt /> },
	];

	return (
		<div className={styles.btn_group_mob}>
			{data.map((item) => {
				const isCurrentPage = item.navi === location.pathname;
				const titleStyle = isCurrentPage
					? { color: 'darkgreen' }
					: { color: 'grey' };
				const iconStyle = isCurrentPage
					? { color: 'green' }
					: { color: 'grey' };

				return (
					<Link className={styles.btn_mob} to={item.navi} key={item.id}>
						<div className={styles.icon} style={iconStyle}>
							{item.icon}
						</div>
						<p className={styles.title} style={titleStyle}>
							{item.title}
						</p>
					</Link>
				);
			})}
		</div>
	);
}

export default BottomNav;
